import axios from '@atheneum/api'

export const validateProject = async (project, feeData) => {
  let isValid = true;
  let errMsg = "";
  // Cut off Date for old way of invoicing
  const cutOffDate = new Date('2021-09-16').getTime()
  const projectCreationDate = new Date(project.created_at).getTime()
  const isProjectAfterCutOffDate = cutOffDate < projectCreationDate
  // Not sure why this project id is hardcoded, ask Richard?
  const hardCodedProjectIds = [70251]
  const isProjectInHardcodedList = hardCodedProjectIds.includes(project.id)
  const FREE_CALL_FEE_TYPE_ID = 14

  if (
    // is true when project id is not 70251
    !isProjectInHardcodedList &&
    // is true when project created after 2021-09-16
    isProjectAfterCutOffDate &&
    // is true when capiProjectType is not LOP or feeData.type is not FEECOST
    // LOP is free project for Mckinsey
    !(project.capiProjectType === 'LOP' && feeData.type === 'FEECOST') &&
    // is true when feeData type is not COST
    feeData.type !== 'COST' &&
    feeData.feeTypeId !== FREE_CALL_FEE_TYPE_ID &&
    // is true when invoicingEntityId does not exist and projectSource is capi-mckinsey
    (!project.invoicingEntityId && project.projectSource === 'capi-mckinsey')) {
    isValid = false;
    // Make request to CAPI service to check invoice name and address with project id
    const message = await checkInvoiceOfProject(project.id)

    errMsg = message;
  }

  return {
    isProjectInHardcodedList,
    isProjectAfterCutOffDate,
    isValid,
    errMsg
  }
}

const checkInvoiceOfProject = async (projectId) => {
  const { message } = (await axios({
    method: 'get',
    url: `${process.env.REACT_APP_CAPI_SERVICE_URL}/project/check/invoice/${projectId}`,
  })).data

  if (message) {
    return message;
  }

  return `Unknown Error while checking Capi project invoice for ${projectId}`;
}
